module.exports = __webpack_public_path__ + "img/arrow-right.7206ef6c.svg";